import { render, staticRenderFns } from "./BuildingAmenities.vue?vue&type=template&id=2b08f4ea&scoped=true&"
import script from "./BuildingAmenities.vue?vue&type=script&lang=js&"
export * from "./BuildingAmenities.vue?vue&type=script&lang=js&"
import style0 from "./BuildingAmenities.vue?vue&type=style&index=0&id=2b08f4ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b08f4ea",
  null
  
)

export default component.exports